import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white sm:w-80 rounded-lg select-none" }
const _hoisted_2 = { class: "px-4 py-2" }
const _hoisted_3 = { class: "font-medium block text-lg text-center" }
const _hoisted_4 = { class: "text-sm mt-2 text-center" }

import {onBeforeUnmount} from "vue";
import {resolveConfirmation} from "@/dialog";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    confirmationId: {},
    title: {},
    text: {}
  },
  setup(__props: any) {

const props = __props;



onBeforeUnmount(() => {
  resolveConfirmation(props.confirmationId, false);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.text), 1 /* TEXT */)
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(resolveConfirmation)(_ctx.confirmationId, true))),
      class: "bg-white hover:bg-gray-100 border-t-2 py-2 text-center block w-full text-blue-500"
    }, " OK "),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(resolveConfirmation)(_ctx.confirmationId, false))),
      class: "bg-white hover:bg-gray-100 border-t-2 py-2 text-center block w-full text-blue-500"
    }, " Peruuta ")
  ]))
}
}

})